import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Home from './components/Home';
import FormObat from './components/FormObat';
import Ttb from './components/Ttb';
import UserManagement from './components/UserManagement';
import GroupUser from './components/GroupUser';
import UserPermission from './components/UserPermission';
import DataPelanggan from './components/DataPelanggan';
import DataSupplier from './components/DataSupplier';
import DataSp from './components/DataSp';
import StokBarang from './components/StokBarang';

// Komponen helper untuk membatasi akses halaman Home tanpa login
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/" replace />;
  }
  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Route Login */}
        <Route path="/" element={<Login />} />

        {/* Route Dashboard */}
        <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />

        {/* Route Master Data Barang — PascalCase & lowercase alias */}
        <Route path="/FormObat" element={<ProtectedRoute><FormObat /></ProtectedRoute>} />
        <Route path="/formobat" element={<ProtectedRoute><FormObat /></ProtectedRoute>} />

        {/* Route Tanda Terima Barang — backend kirim /ttb (lowercase) */}
        <Route path="/Ttb" element={<ProtectedRoute><Ttb /></ProtectedRoute>} />
        <Route path="/ttb" element={<ProtectedRoute><Ttb /></ProtectedRoute>} />

        {/* Route User Management */}
        <Route path="/UserManagement" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
        <Route path="/usermanagement" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />

        {/* Route Group User */}
        <Route path="/GroupUser" element={<ProtectedRoute><GroupUser /></ProtectedRoute>} />
        <Route path="/groupuser" element={<ProtectedRoute><GroupUser /></ProtectedRoute>} />

        {/* Route Setting Permission */}
        <Route path="/UserPermision" element={<ProtectedRoute><UserPermission /></ProtectedRoute>} />
        <Route path="/userpermision" element={<ProtectedRoute><UserPermission /></ProtectedRoute>} />
        <Route path="/UserPermission" element={<ProtectedRoute><UserPermission /></ProtectedRoute>} />
        <Route path="/userpermission" element={<ProtectedRoute><UserPermission /></ProtectedRoute>} />

        {/* Route Master Data Pelanggan */}
        <Route path="/DataPelanggan" element={<ProtectedRoute><DataPelanggan /></ProtectedRoute>} />
        <Route path="/datapelanggan" element={<ProtectedRoute><DataPelanggan /></ProtectedRoute>} />

        {/* Route Master Data Supplier */}
        <Route path="/DataSupplier" element={<ProtectedRoute><DataSupplier /></ProtectedRoute>} />
        <Route path="/datasupplier" element={<ProtectedRoute><DataSupplier /></ProtectedRoute>} />

        {/* Route Surat Pesanan (SP) */}
        <Route path="/DataSp" element={<ProtectedRoute><DataSp /></ProtectedRoute>} />
        <Route path="/datasp" element={<ProtectedRoute><DataSp /></ProtectedRoute>} />

        {/* Route Stok Barang / Saldo */}
        <Route path="/StokBarang" element={<ProtectedRoute><StokBarang /></ProtectedRoute>} />
        <Route path="/stokbarang" element={<ProtectedRoute><StokBarang /></ProtectedRoute>} />

        {/* Fallback ke login */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;